import { isNil } from 'lodash';

export default {
  computed: {
    articleLink() {
      return !isNil(this.item) && !isNil(this.item.link) ? this.item.link : '#';
    }
  }
};
